import { useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetFareharbor as ExternalWidgetFareharborType } from "../../types/ExternalWidget";

export type ExternalWidgetFareharborProps = Omit<ExternalWidgetFareharborType, "__typename"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
};

export function ExternalWidgetFareharbor({ itemId, flowId, slug, ButtonComponent }: ExternalWidgetFareharborProps) {
    const [t] = useNextTranslation("externalWidget");
    const Button = ButtonComponent ?? ProductBookNowButton;

    const url = new URL(`https://fareharbor.com/embeds/book/${slug}/items/${itemId}/?full-items=yes`);

    url.searchParams.set("flow", String(flowId));

    return (
        <>
            <Button href={url.toString()}>{t("fareharbor.availabilityButton.label")}</Button>
        </>
    );
}
